<template>
  <div>
    <div class="TitleFont">
      <!-- 相关游戏 -->
      <p>{{$t('QRCode.relatedGames')}}</p>
    </div>
    <div class="wrapper-container">
      <div class="hot-game-list">
        <div class="HotsGame"
             v-for="(item, ind) in allGameList"
             :key="ind"
             @click="ToProduct(item.game_id)">
          <img :src="item.logo_url">
          <div>
            <p class="GameBriefTitle">{{item.game_name}}</p>
            <p class="GameBrief">{{item.issuer}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
//import 'element-ui/lib/theme-chalk/display.css'
export default {
  data () {
    return {
      allGameList: [],
      showMore: false,
      isLongContent: false
    }
  },
  created () {
    // 获取游戏列表
    this.$axios.get(this.apiUrl.API.GameList, {
      params: {
        gameId: this.$route.query.gameId
      }
    })
      .then((res) => {
        res.data.data.forEach(element => {
          element.preview_url = element.preview_url.split(',')
        });
        this.allGameList = res.data.data
      })
  },
  methods: {
    ToProduct (id) { // 跳转游戏详情
      this.$router.push({
        path: `/product?id=${id}`
      })
    },
    _toggleShowMore () {
      this.showMore = !this.showMore
    }
  }
}
</script>

<style lang="less" scoped>
.TitleFont {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 1.333rem;
  padding-left: 0.667rem;
  margin: 1.333rem 0 1rem 0;
  padding: 0;
  /* border-bottom: 1px solid #ddd; */
}
.TitleFont > p {
  color: #333;
  padding-left: 8px;
  border-left: 0.5rem solid #ff7473;
}

.hot-game-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 10px 0 10px;
  background: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.HotsGame {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .GameBriefTitle {
    font-size: 20px;
    color: #101010;
    margin: 0 0 5px 0;
  }
  .GameBrief {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 190px;
    overflow: hidden;
    font-size: 12px;
    color: rgba(16, 16, 16, 0.48);
  }
  img {
    width: 5.167rem;
    height: 5.167rem;
    border-radius: 1rem;
    margin: 0 0.6rem 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/correlationGame.vue